import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { VariablesGlobales } from '../services/globals';
import swal from 'sweetalert2';
import { EncryptDecryptService } from '../services/encrypt-decrypt.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ConfigService } from '../services/config.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  test: Date = new Date();
  config = ConfigService.GetItem;

  constructor(private encdec: EncryptDecryptService,
    public dialog: MatDialog,
    @Inject('BASE_URL') baseUrl: string,
    private http: HttpClient,
    public router: Router) { }

  ngOnInit(): void {
  }
 
  facebook() {
    window.open(this.config('f_fb')?.txt, '_blank');
  }
  linkedin() {
    window.open(this.config('f_linkedin')?.txt, '_blank');
  }
  twitter() {
    window.open(this.config('f_twitter')?.txt, '_blank');
  }
  insta() {
    window.open(this.config('f_insta')?.txt, '_blank');
  }
  youtube() {
    window.open(this.config('f_youtu')?.txt, '_blank');
  }
  pinterest() {
    window.open(this.config('f_pinterest')?.txt, '_blank');
  }

  openDialogSend(): void {
    event.preventDefault();
    const dialogRef = this.dialog.open(DialogOverviewProbDialog, {
      width: '80%',
      data: {
        page: this.router.url,
        corps: '',
      },
      panelClass: 'custom-modalbox'
    });

    dialogRef.afterClosed().subscribe(resulta => {
      if (resulta) {
        const userInfo: Mail = {
          from: 'vich@rhprofiler.info',
          to: resulta.email,
          corps: resulta.corps + '\r\n\r\n\r\nUrl : ' + this.router.url + '\r\nEmail : ' + resulta.email + '\r\nTel : ' + resulta.sms,
          subject: resulta.obj,
          sms: resulta.sms
        }
        let data = this.encdec.getEncrypt( JSON.stringify(userInfo));
        const formData = new FormData();
        formData.append('datas', data);
        this.http.post('https://api2.sitederecrutement.com/Home/SendMailProb?apikey=' + localStorage.getItem('apikey'), formData, { responseType: "text" }).subscribe(
          (result) => {
            swal.fire({
              title: "Votre rapport est bien envoyé.",
              buttonsStyling: false,
              customClass: {
                confirmButton: "btn btn-rose",
              },
              icon: "success",
              iconColor: 'd '
            });
          }
        )
      }
    });
  }
}

export class Result {
  constructor(public result: string) { }
}

interface Mail {
  from: string;
  to: string;
  subject: string;
  corps: string;
  sms: string;
}

export interface DialogData {
  page: string;
  email: string;
  corps: string;
  sms: string;
}

@Component({
  selector: 'dialog-prob-send',
  templateUrl: 'dialog-prob-send.html'
})
export class DialogOverviewProbDialog {

  public idannonce: number;
  public _email: string = '';
  public _sms: string = '';
  public obj: string;
  public corps: string;

  public controlForm: FormGroup;

  constructor(public dialogRef: MatDialogRef<DialogOverviewProbDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public param: VariablesGlobales) {

    this.controlForm = new FormGroup({
      email: new FormControl(this._email, [
        Validators.required,
        Validators.pattern('(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))')
      ]),
    });
  }

  get email() { return this.controlForm.get('email'); }


  onNoClick(): void {
    this.dialogRef.close();
  }

  onClick(): void {
    this.dialogRef.close({
      email: this.email.value,
      corps: this.corps
    });
  }

}
